// extracted by mini-css-extract-plugin
module.exports = {"product-title":"VIP_ProductTitle__product-title","productTitle":"VIP_ProductTitle__product-title"};